export default __webpack_public_path__ + "static/3-31a4b9e040bc8a951fb2e1a4aac78810.png";